import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuSliderOptions} from '@Components/contextual-menu/components/contextual-menu-slider-options';
import {
  ITEM_TINT_DISPLAY_MAX,
  ITEM_TINT_DISPLAY_MIN,
  ITEM_TINT_MAX,
  ITEM_TINT_MIN,
} from '@Components/poster-editor/components/poster-editing-side-panel/components/item-tint-option/item-tint-option.types';

interface BaseTintOpacityOptionProps {
  tintOpacity: number;
  className?: string;
  updateOpacity(value: number, undoable?: boolean): void;
}

export function BaseTintOpacityOption({className = '', ...props}: BaseTintOpacityOptionProps): ReactElement<any> | null {
  const onChangeOpacity = (updatedValue: number): void => {
    props.updateOpacity(updatedValue, false);
  };

  const onChangeOpacityEnded = (updatedValue: number): void => {
    props.updateOpacity(updatedValue);
  };

  return (
    <ContextualMenuSliderOptions
      id="item-tint-opacity-option"
      value={props.tintOpacity}
      className={className}
      label={window.i18next.t('pmwjs_opacity')}
      range={{min: ITEM_TINT_MIN, max: ITEM_TINT_MAX}}
      transformDisplay={{min: ITEM_TINT_DISPLAY_MIN, max: ITEM_TINT_DISPLAY_MAX}}
      onChange={onChangeOpacity}
      onChangeEnded={onChangeOpacityEnded}
    />
  );
}
